import PropTypes from "prop-types";
import { useState } from "react";
// @mui
import { Box, Stack, Typography, Collapse } from "@mui/material";
// hooks
import TopNavItem from "./TopNavItem";
// styles
import { StyledIcon } from "./styles";
// context
import { useAuth } from "../../../context/AuthContext";
// utils
import { APPROVED_THROUGH_DIY_FLOW_USER_STATUS } from "../../../utils/constants";
// icons
import { Icon } from "@mdi/react";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";

// ----------------------------------------------------------------------

TopNavList.propTypes = {
  subRoutes: PropTypes.array,
  parentPath: PropTypes.string,
};

export default function TopNavList({ list }) {
  const { user } = useAuth();
  const isApprovedThroughDiyUser =
    user?.data?.status === APPROVED_THROUGH_DIY_FLOW_USER_STATUS;

  const [open, setOpen] = useState(!isApprovedThroughDiyUser);

  const handleToggle = () => {
    setOpen(!open);
  };

  const subRoutes = list?.routes || [];
  const parentPath = list?.path;

  const filteredSubRoutes = isApprovedThroughDiyUser
    ? subRoutes.filter((item) =>
        item.allowedUserStatuses.includes(
          APPROVED_THROUGH_DIY_FLOW_USER_STATUS,
        ),
      )
    : subRoutes;

  return (
    <Stack
      key={list.label + list.path}
      sx={{
        borderRadius: 1,
        background: "#FFFFFF10",
        padding: 0.5,
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isApprovedThroughDiyUser && (
          <StyledIcon sx={{ mt: 2 }}>{list.icon}</StyledIcon>
        )}
        <Typography
          variant="caption"
          sx={{
            color: "white",
            textAlign: "center",
            mt: "4px",
            fontWeight: 500,
            fontSize: "10px",
            lineHeight: 1.2,
          }}
        >
          {isApprovedThroughDiyUser ? "Affiliate Setup" : list.label}
        </Typography>
      </Box>
      <Collapse in={open} unmountOnExit>
        {filteredSubRoutes.map((item) => (
          <TopNavItem item={{ ...item, path: `${parentPath}/${item.path}` }} />
        ))}
      </Collapse>
      {isApprovedThroughDiyUser && (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          onClick={handleToggle}
        >
          {open ? (
            <Icon path={mdiChevronUp} size={2} color="white" />
          ) : (
            <Icon path={mdiChevronDown} size={2} color="white" />
          )}
        </Stack>
      )}
    </Stack>
  );
}
